import _extends from "@babel/runtime/helpers/esm/extends";
import { DATA_GRID_DEFAULT_SLOTS_COMPONENTS } from '@mui/x-data-grid/internals';
import { GridProColumnMenu } from "../components/GridProColumnMenu.mjs";
import { GridColumnHeaders } from "../components/GridColumnHeaders.mjs";
import { GridHeaderFilterMenu } from "../components/headerFiltering/GridHeaderFilterMenu.mjs";
import { GridHeaderFilterCell } from "../components/headerFiltering/GridHeaderFilterCell.mjs";
import { GridDetailPanels } from "../components/GridDetailPanels.mjs";
import { GridPinnedRows } from "../components/GridPinnedRows.mjs";
import materialSlots from "../material/index.mjs";
export const DATA_GRID_PRO_DEFAULT_SLOTS_COMPONENTS = _extends({}, DATA_GRID_DEFAULT_SLOTS_COMPONENTS, materialSlots, {
  columnMenu: GridProColumnMenu,
  columnHeaders: GridColumnHeaders,
  detailPanels: GridDetailPanels,
  headerFilterCell: GridHeaderFilterCell,
  headerFilterMenu: GridHeaderFilterMenu,
  pinnedRows: GridPinnedRows
});